(($, Drupal, drupalSettings) => {

  const endPoint = '/assisdent/';
  Drupal.assisDentCaller = function(){
    //console.log('Im Here',new Date().toISOString());
    this.init();
  }
  // AssisdentGlobalAjax
  if (typeof Drupal.aga == 'undefined') {
    Drupal.aga = {
      prefetchedUsers: {},
      ajaxCall: false
    };
  }

  // Make minified file more minified.
  const newDate = function() {
    switch(arguments.length){
      case 0:
        return new Date();
      case 1:
        return new Date(arguments[0]);
    }
  }

  Drupal.assisDentCaller.prototype = {

    init: function(){
      // Initialize date to queries.
      this.startDate = newDate();
      // this funny little thing fixes the timezone issues.
      this.startDate.setHours( (this.startDate.getTimezoneOffset() / 60) * -1, 0, 0, 0);
      this.startDate = this.startDate.toISOString();

      // End Date only six months away so maybe we got all the dates....
      this.endDate = newDate(this.startDate)
      this.endDate.setMonth( this.endDate.getMonth() + 6);
      this.endDate = this.endDate.toISOString();
    },

    // Helper to provide ajax queries.
    _ajax: function(url, cb){
      var windowLocation = window.location;

      if (windowLocation.href.indexOf('/hammashoito/') < 0 &&
          windowLocation.href.indexOf('/sv/tandvard/') < 0 &&
          windowLocation.href.indexOf('/en/dental-care/') < 0) {
        return;
      }

      Drupal.aga.ajaxCall = $.ajax({
        url: windowLocation.protocol + '//' + windowLocation.hostname + endPoint + url,
        error: () => {
          console.log('error');
        }
      }).done( data => {

        // When done we add items to proper cache so we can use it later and avoid not needed queries.
        const parsedSlots = data.Slots.filter( slot => {

          const checkValue = drupalSettings.availableReasons.indexOf(slot.ReasonId);
          if (checkValue > -1 ){
            // Unless this id aint got times we crate spot for it.
            if(typeof Drupal.aga.prefetchedUsers[slot.ResourceId] === 'undefined') {
              Drupal.aga.prefetchedUsers[slot.ResourceId] = [];
            }

            // Push it, and commit filter status.
            Drupal.aga.prefetchedUsers[slot.ResourceId].push(slot);
          }

          return checkValue;
        });

        // reset ajax call and callback function time.
        Drupal.aga.ajaxCall = false;
        cb({
          ...data,
          Slots: parsedSlots,
        });
      });
    },

    // Helper to wrap multicall actions to query.
    getTimes: function(userIds, branch, cb, take, additions = '') {
      // What ids r not in cache?
      const getQueriedUserIds = (userids, cached) => {
        return userids.filter(userid => cached ? typeof Drupal.aga.prefetchedUsers[userid] === 'undefined' : typeof Drupal.aga.prefetchedUsers[userid] !== 'undefined');
      }
      // Return cached users.
      const getCachedUserIds = (userids) => {
        var ids = getQueriedUserIds(userIds, false).map( ids => Drupal.aga.prefetchedUsers[ids]);
        if (typeof ids[0] !== 'undefined') {
          return ids[0];
        }
        return [];
      }

      // This is function to determine what is served from cacahe and what is gonna be fetched.
      const mergeOldAndNew = (userIds, cb) => {
        const joiner = '&' + (branch ? 'branchIds' : 'personIds') + '[]=';
        const askThese = getQueriedUserIds(userIds, true);
        const getAnothersIdsSlot = getCachedUserIds(userIds);
        if (askThese.length === 0) {
          cb({
            Days: [],
            Slots: getAnothersIdsSlot,
          });
          return;
        }

        this._ajax(
          'availabletimes?startDate=' + this.startDate +
          additions +
          '&endDate=' + this.endDate +
          joiner + askThese.join(joiner) +
          '&take=' + take +
          '&resultType=Full',
          resp => {
            cb({
              ...resp,
              Slots: resp.Slots.concat(getAnothersIdsSlot),
            });
          }
        );
      }

      // Test shall we wait previous query or create new one.
      if (!Drupal.aga.ajaxCall) {
        mergeOldAndNew(userIds, cb);
      } else {
        Drupal.aga.ajaxCall.done( e => {
          mergeOldAndNew(userIds, cb)
        });
      }
    },


    getBranchAvailableTimes: function(userIds, cb){

      // parse results to better format.
      const _parseKalkkuna = (data, userIds) => {
        var reasons = {}, employees = {};
        const putThing = (obj, pointer, value) => {
          if (obj[pointer] === undefined) {
            obj[pointer] = [];
          }
          obj[pointer].push(value);
        }

        if( data.Slots.length > 0 ){
          data.Slots.forEach( slot => {
            putThing(reasons, slot.ReasonId, slot);
            putThing(employees, slot.ResourceId, slot);
          });
        }
        return {
          'reason': reasons,
          'employees': employees,
        };
      }
      this.getTimes(userIds, true, resp => {
        cb(_parseKalkkuna(resp,userIds));
      }, 2000);
    },

    getPersonsAvailableTimes: function(userIds, cb, singleTime){

      // Helper to remove older times and return new times for the for the caller.
      const _parsePersonsAvailableTimes = (data, userIds, branchOnly) => {
        var r = {};
        userIds.forEach( user => {
          r[user] = [];
        });

        if( data.Slots.length > 0 ){
          const currentDate = newDate();
          var filteredSlots = data.Slots.filter( slot => {
            return newDate(slot.StartTime) > currentDate;
          } )
          filteredSlots.sort((a,b) => {
            if(a.StartTime == b.StartTime) {
              return 0;
            }
            return newDate(a.StartTime) > newDate(b.StartTime) ? 1 : -1
          });
          filteredSlots.forEach( slot => {
            if (r[slot.ResourceId] !== undefined) {
              var foundThatTime = false;
              r[slot.ResourceId].forEach( splot => {
                if( splot.StartTime == slot.StartTime ){
                  foundThatTime = true;
                }
              });
              if(!foundThatTime){
                r[slot.ResourceId].push({
                  ...slot,
                  branchOnly: branchOnly
                });
              }
            }
          });
        }
        return r;
      }

      // Shall there be addition like branch idf or similiar to that.
      var BranchAddition = "", takeTime = 1000;
      const office = document.querySelector('article.node--type-office[data-branch-uuid]');
      if (office) {
        BranchAddition = '&branchIds[]=' + office.dataset.branchUuid;
      }

      if (typeof singleTime !== 'undefined') {
        takeTime = 5;
      }

      this.getTimes(userIds, false, resp => {
        cb(_parsePersonsAvailableTimes(resp,userIds, office ? office.dataset.branchUuid : false ));
      }, takeTime, BranchAddition);
    },


    getUrlForAppoitment: function( slot ){
      return this.getBaseUrlForAppoitment(slot.BranchId, slot.ResourceId, slot.ReasonId) + '&startTime=' + slot.StartTime + '&endTime=' + slot.EndTime;
    },

    /**
     * Link creator to time reservation service.
     */
    getBaseUrlForAppoitment: function(branch,employee,reason){
      return 'https://plus.plusterveys.fi/ajanvaraus?' +
        (branch   === 'none' || branch === undefined || branch === '' ? '' : '&branch=' + branch) +
        (employee === 'none' ? '' : '&employee=' + employee) +
        (reason   === 'none' ? '' : '&reason=' + reason);
    },

    getFormattedTime: function( time ) {
      const formatDrupalDateToLocaleDateString = () => {
        switch(drupalSettings.path.currentLanguage){
          case 'fi':
            return 'fi-FI';
          default:
            return drupalSettings.path.currentLanguage;
        }
      }

      const createFormattedDate = date => {
        var asd = newDate(date);
        var parsedHours = date.substr(11,2);
        asd.setHours(parsedHours)
        return asd;
      }

      return createFormattedDate(time).toLocaleDateString(formatDrupalDateToLocaleDateString(),{
        weekday: 'short',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },

    getUrlElementForAppoitment: function( slot ){
      // All needed security measures.
      var a = document.createElement('a');
      a.href = this.getUrlForAppoitment(slot);
      a.target = '_blank';
      a.rel = "noopener noreferrer";

      // Format time according the drupal language to match correct format
      a.innerHTML = this.getFormattedTime(slot.StartTime)
      return a;
    }
  }
})(jQuery, Drupal, drupalSettings);
